import { makeStyles } from 'tss-react/mui';

const useStylesTableRowGroupName: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  tableRowGroupName: {
    backgroundColor: `${theme.palette.primary.main} !important`,
    '& > th': {
      zIndex: '22 !important',
      backgroundColor: `${theme.palette.primary.main} !important`,
      borderTop: `1px solid ${theme.palette.common.white} !important`,
      color: theme.palette.common.white,
      border: 'none',
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: `${theme.palette.primary.main} !important`,
        borderTop: `1px solid ${theme.palette.common.white} !important`,
      },
    },
  },
}));

export default useStylesTableRowGroupName;
